module.exports = __webpack_public_path__ + "static/assets/f13e04291bdb5e0ae696be511cf0a77f.png";